import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import TasksApi from '../../../../api/public/TasksApi';

export const useGetTaskListTemplate = () => {
    const { propertyId } = useParams<{ propertyId: string }>();

    return useQuery(['ListTemplates', propertyId], () => TasksApi.listTemplates(propertyId));
};
